// api
export const METHOD_POST = 'POST'
export const METHOD_GET = 'GET'
export const METHOD_PUT = 'PUT'
export const METHOD_DELETE = 'DELETE'